import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const ColumnStyles = ({
  theme,
  backgroundColor,
  borderType,
  borderColor,
  svg,
  aspectRatio,
  borderRadius,
  customPosition,
}) => {
  const colors = theme?.colors
  const background = colors?.[backgroundColor]?.base?.hex
  const readable = colors?.[backgroundColor]?.base?.readable
  const borderFill = colors?.[borderColor]?.base?.hex || borderColor || null
  const border = theme?.components?.Column?.border
  const fullWidthImage = theme?.components?.Column?.image === 'full'
  const backgroundOverride =
    theme?.backgroundColors?.[backgroundColor]?.textColor
  const textColor = backgroundOverride || readable

  return css`
    display: flex;
    flex-direction: column;
    background-color: ${background} !important;
    border-radius: ${theme?.radius};
    padding: ${theme.spacing.md};

    .content {
      height: 100%;
      display: flex;
      flex-direction: column;

      u {
        color: ${textColor};
      }
    }
    /* NOTE: in a later version we will refactor to accommodate alignment of multiple buttons/items in a column */
    .content:has(> .leshen-link:last-child) > .leshen-link:last-child {
      margin-top: auto;
    }

    > * {
      color: ${textColor};

      &:visited {
        color: ${textColor};
      }
    }

    ${borderType === 'topbar' &&
    `
      border-top: ${border.topbar.width || '10px'} solid ${borderFill};
    `}

    ${borderType === 'stroke' &&
    `
      border: ${border.stroke.width || '1px'} solid ${
      borderFill || colors.primary.base.hex
    };
    `}

      ${fullWidthImage &&
    !svg &&
    `
      padding: 0;

      .content {
        padding: ${theme.spacing.md};
      }
    `}

    img {
      max-width: 100%;
      object-position: ${customPosition} !important;
      aspect-ratio: ${aspectRatio} !important;
      border-radius: ${borderRadius} !important;
    }
  `
}
export const Column = styled.div(ColumnStyles)
